


import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MasterlayoutRoutingModule } from './masterlayout-routing.module';
import { MasterlayoutComponent } from './masterlayout.component';
import { FilterComponent } from './Pages/shared/filter/filter.component';
import { BrowserModule } from '@angular/platform-browser';
import { UsersModule } from './pages/users/users.module';
import { AccountModule } from './Pages/account/account.module';
import { SharedModule } from './Pages/shared/shared.module';
import { AuthModule } from './Pages/core/auth.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthenticationModule } from './Pages/authentication/authentication.module';
import { GlobalErrorHandler } from './Pages/shared/Services/GlobalErrorHandler.service';
import { ErrorService } from './Pages/shared/Services/ErrorService.service';
import { HttpErrorInterceptor } from './Pages/shared/Services/HttpErrorInterceptor.service';
import { HomeComponent } from './Pages/home/home.component';
import { BlockUIModule } from 'ng-block-ui';
// import { BBSFControlsModule } from 'bbsf-controls';
// import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


import { AsideComponent } from './Pages/_layout/components/aside/aside.component';

import { InlineSVGModule } from 'ng-inline-svg';
import { NgbDropdownModule, NgbModal, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutInitService } from './_metronic/core/services/layout-init.service';
import { LayoutService } from './_metronic/core/services/layout.service';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from './Pages/core/authentication/auth.guard';
import { injectionModuleService } from './Pages/shared/Services/injectionModuleService.service';
import { InjectedModule } from './Pages/shared/models/InjectedModuleModel/InjectedModule';
import { HeaderComponent } from './Pages/_layout/components/header/header.component';
import { ContentComponent } from './Pages/_layout/components/content/content.component';
import { FooterComponent } from './Pages/_layout/components/footer/footer.component';
import { ScriptsInitComponent } from './Pages/_layout/components/scripts-init/scripts-init.component';
import { AsideMenuComponent } from './Pages/_layout/components/aside/aside-menu/aside-menu.component';
import { TopbarComponent } from './Pages/_layout/components/topbar/topbar.component';
import { CoreModule } from './Pages/core/core.module';
import { AuthService, BBSFUtilitiesModule, EnvironmentService, StylesBundleService ,RequestHandlerService, UtilityService, BBSFTranslateService, MasterLayoutService} from 'bbsf-utilities';

import {ToolbarModule} from './Pages/_layout/components/toolbar/toolbar.module'
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MasterlayoutComponent,
    FilterComponent,
    AsideComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    ScriptsInitComponent,
    AsideMenuComponent,
    TopbarComponent,

  ],
  imports: [
    BlockUIModule.forRoot(),
    ClipboardModule,
    AuthenticationModule,
    CommonModule,
    MasterlayoutRoutingModule,
    NgbModule,
    ToolbarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    AccountModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    InlineSVGModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    BBSFUtilitiesModule
  ],
  providers: [
    LayoutService,
    LayoutInitService,
    StylesBundleService,
    EnvironmentService,
    AuthService,
    RequestHandlerService,
    UtilityService,
    AuthGuard ,
    BBSFTranslateService,
    MasterLayoutService,
    NgbModal,
  ],

})
export class MasterlayoutModule {
  // static setDynamicProviders(environment: any) {
  //   environmentService.setEnvironmentObject(environment);
  //   return MasterlayoutModule;
  // }

  static setDynamicModules(InjectedModules:InjectedModule[]) {
    injectionModuleService.injectNewModules(InjectedModules);
    return MasterlayoutModule;
  }


}
